<template>
  <div id="main-wrapper">
    <b-overlay
        id="overlay-background"
        :show="isBusy"
        variant="white"
        spinner-variant="success"
        :opacity="1"
       >
      <router-view/>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="clock" font-scale="3" animation="cylon" variant="primary-sub1"></b-icon>
          <p id="cancel-label"> <span class="text-primary-sub1 font-weight-bold">Παρακαλώ περιμένετε...</span></p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>


import {mapState} from "vuex";

export default {
  name: 'App',
  computed: {
    ...mapState(
        {
          isBusy: state => state.sub1.isBusy
        },
    ),
  },
  created() {
    window.addEventListener('beforeunload', function (e) {
      e.preventDefault();
      e.returnValue = '';
    });
    if (!this.$store.getters['auth/isAuthenticated']) {
      this.$store.dispatch('logout')
      this.$router.push('/');

    }
  }
}
</script>

<style>
.session-timer {
  position: fixed;
  left: 20px;
  bottom: 10px;
  cursor: pointer;
  width: 3px;
  color: #fff;
  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  -o-transition: all .5s;
  -ms-transition: all .5s;
  transition: all .5s;
}
</style>
